
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sellers-landing",
      function () {
        return require("private-next-pages/sellers-landing.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sellers-landing"])
      });
    }
  